import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useBackend } from '../../../Hooks/UseBackend';
import { useBonkGateway } from '../../../Hooks/useBonkGateway';
import { CommonUseBubblesProps, useBubbles } from './useBubbles';
import { FeedBubble } from '../types';

export function useBonkBubbles(props: CommonUseBubblesProps) {
    const { getBonkBubbles } = useBackend();

    const { bonkGatewayClient } = useBonkGateway();

    return useBubbles<Api.Bonk.DTO.LetsBonkBubble, Api.Bonk.DTO.LetsBonkBubbleUpdate, FeedBubble<Api.Bonk.DTO.LetsBonkToken>>({
        ...props,
        getBubbles: getBonkBubbles,
        client: bonkGatewayClient,
        updateEventName: Api.Bonk.Gateway.Event.BubbleUpdate,
        transform: ({ letsBonkTokens, ...bubble }) => ({
            ...bubble,
            tokens: letsBonkTokens,
        }),
    });
}
